import api from "../api";

const unwrapData = (response) => response.data?.data ?? response.data;

export const personsService = {

  getPersons: async ({ companyId } = {}) => {
    const res = await api.get("/api/persons/persons/", {
      params: companyId ? { company: companyId } : {},
    });
    return unwrapData(res);
  },

  createPerson: async (payload) => {
    const res = await api.post("/api/persons/persons/", payload);
    return unwrapData(res);
  },

  getPersonDetail: async (personId) => {
    const res = await api.get(`/api/persons/persons/${personId}/`);
    return unwrapData(res);
  },

  updatePerson: async (personId, payload) => {
    const res = await api.patch(`/api/persons/persons/${personId}/`, payload);
    return unwrapData(res);
  },

  deletePerson: async (personId) => {
    const res = await api.delete(`/api/persons/persons/${personId}/`);
    return unwrapData(res);
  },
};
